import GoogleTagManagerKit from '@mparticle/web-google-tag-manager-kit';
import mParticle from '@mparticle/web-sdk';
import Constants from 'expo-constants';

import { getConfigValue, getCurrentCommitHash } from 'utils/environment';

const isProduction = getConfigValue({ key: 'env' }) === 'prod';

// Note: This does not support multi region applications currently.
// If there is an expectation for this to utilize multi region, we will
// need to adjust this to init within the react runtime, and not crash
// the MparticleAdapters when mParticle has not yet initialized.
const region = getConfigValue({ key: 'buildRegion' });

const mParticleConfig = {
  appVersion: Constants.expoConfig?.version || getCurrentCommitHash(),
  userClient: navigator.userAgent || '',
  isDevelopmentMode: !isProduction,
  logLevel: isProduction ? 'none' : 'verbose',
  dataPlan: {
    planId: 'data_plan',
  },
};

const apiKeys = getConfigValue({ key: 'apiKeys', region });
const mParticleKey = apiKeys.mParticle;

GoogleTagManagerKit.register(mParticleConfig);
mParticle.init(mParticleKey, mParticleConfig);

export function noop() {}
